import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

export default function CookieConsent() {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShowBanner(false);
  };

  const handleReject = () => {
    localStorage.setItem('cookieConsent', 'rejected');
    setShowBanner(false);
  };

  return (
    <AnimatePresence>
      {showBanner && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.5 }}
          className="fixed bottom-0 left-0 right-0 z-50 bg-[#0A0A0A] border-t border-[#00E5FF]/20 shadow-2xl"
        >
          <div className="max-w-7xl mx-auto px-4 sm:px-6 py-4 sm:py-6">
            <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
              <div className="flex-1">
                <div className="flex items-start gap-3">
                  <i className="ri-information-line text-[#00E5FF] text-xl mt-1 flex-shrink-0"></i>
                  <div>
                    <h3 
                      className="text-white font-bold text-sm mb-2" 
                      style={{ fontFamily: 'Orbitron, sans-serif' }}
                    >
                      Informacja o cookies
                    </h3>
                    <p 
                      className="text-[#C0C7CF] text-xs sm:text-sm leading-relaxed" 
                      style={{ fontFamily: 'Inter, sans-serif' }}
                    >
                      Ta strona wykorzystuje pliki cookies w celu zapewnienia prawidłowego działania, personalizacji treści oraz analizy ruchu. 
                      Kontynuując przeglądanie, wyrażasz zgodę na ich użycie. 
                      <a 
                        href="/polityka-prywatnosci" 
                        className="text-[#00E5FF] hover:underline ml-1 cursor-pointer"
                      >
                        Dowiedz się więcej
                      </a>
                    </p>
                  </div>
                </div>
              </div>
              
              <div className="flex items-center gap-3 w-full sm:w-auto">
                <button
                  onClick={handleReject}
                  className="flex-1 sm:flex-none px-6 py-2.5 border border-[#00E5FF]/30 text-[#C0C7CF] text-xs font-semibold hover:bg-[#00E5FF]/10 transition-all duration-300 cursor-pointer whitespace-nowrap"
                  style={{ fontFamily: 'Orbitron, sans-serif' }}
                >
                  Odrzuć
                </button>
                <button
                  onClick={handleAccept}
                  className="flex-1 sm:flex-none px-6 py-2.5 bg-[#00E5FF] text-[#050505] text-xs font-semibold hover:bg-white transition-all duration-300 cursor-pointer whitespace-nowrap"
                  style={{ fontFamily: 'Orbitron, sans-serif' }}
                >
                  Akceptuję
                </button>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
